import logo from "../../assets/images/logo.png";
import loginUser from "../../assets/images/login-image.png";
import thumb from "../../assets/images/thumbs-up.png";
import redHeart from "../../assets/images/red-heart.png";
import handShake from "../../assets/images/handshake.png";
import victoryHand from "../../assets/images/victory-hand.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { errorToast, successToast } from "../common/ToastMessage";

function Login() {
  const navigate = useNavigate();
  const token = localStorage.getItem("_token");
  const emailPattern = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );

  const [formInputs, setFormInputs] = useState([]);
  const [error, setError] = useState([]);
  const [errorAPI, setErrorAPI] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (token !== null) {
      navigate("/");
    }
  }, [token]);

  useEffect(() => {
    if (formInputs?.role === "Employee") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [formInputs]);

  const onInputChangelogin = (event) => {
    setError([]);
    let data = { ...formInputs, [event.target.name]: event.target.value };
    setFormInputs(data);
  };

  const handleInput = (e) => {
    let selectVal = e.target.value;
    if (selectVal == "Employee") {
      console.log("Employee");
      setIsActive(true);
    } else {
      console.log("Admin");
      setIsActive(false);
    }
  };

  const validateForm = () => {
    setError([]);
    let error = {};

    if (!formInputs.email) {
      error.email = "Email is required";
    }
    if (formInputs.email && !emailPattern.test(formInputs.email)) {
      error.email = "Please enter valid email address";
    }
    if (!formInputs.password) {
      error.password = "Password is required";
    }
    if (Object.keys(error).length > 0) {
      setError(error);
      return false;
    }
    return true;
  };

  const onSubmitLogin = async () => {
    if (validateForm()) {
      let payload = {
        employemailid: formInputs?.email,
        Password: formInputs?.password,
        role: isActive ? "Employee" : "Admin",
      };
      try {
        const respnse = await axios.post(
          `${process.env.REACT_APP_API_ENDPOINT_PROD}/api/login`,
          payload
        );
        if (respnse.status === 200) {
          if (respnse.data.status === 200) {
            let _token = respnse?.data?.data?.access_token;
            successToast(respnse?.data?.message);
            localStorage.setItem("_token", _token);
            localStorage.setItem(
              "userData",
              JSON.stringify(respnse?.data?.data?.userdata)
            );

            localStorage.setItem("LoggedInTime", Date().toLocaleString());
            if (respnse?.data?.data?.userdata?.[0]?.role === "Admin") {
              navigate("/management");
            } else if (
              respnse?.data?.data?.userdata?.[0]?.role === "Employee"
            ) {
              navigate("/user");
            }
          } else if (respnse.data.status === 400) {
            const errorr = respnse.data.message;
            errorToast(errorr);
            setErrorAPI(errorr);
          }
        }
      } catch (error) {
        const errorr = error.response.data.message;
        if (errorr) {
          errorToast(errorr);
          setErrorAPI(errorr);
        }
      }
    } else {
      //
    }
  };

  const onClickEye = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login">
      <Container fluid>
        <Row className="align-items-center auth-content">
          <Col xxl={8} xl={6} lg={6} md={6} sm={12} className="mb-md-0 mb-3">
            <div className="left-content">
              <form className="auth-form">
                <Card className="border-0 auth-form-content">
                  <Card.Header className="border-0">
                    <Card.Title className="mb-3">
                      <h5>Welcome!</h5>
                    </Card.Title>
                    <Card.Subtitle className="card-subtitle">
                      <h6>Sign in to continue to IT Idol Technologies.</h6>
                    </Card.Subtitle>
                    <div className="logo-sec">
                      <img src={logo} alt={"logo"} />
                    </div>
                  </Card.Header>
                  <div className="button-tiggle">
                    <div className="inner-button-tiggle">
                      <Button
                        className={!isActive ? "admin-active" : "inactive"}
                        onClick={(e) => handleInput(e)}
                        value="Admin"
                      >
                        Admin
                      </Button>
                      <Button
                        className={isActive ? "admin-active" : "inactive"}
                        onClick={(e) => handleInput(e)}
                        value="Employee"
                      >
                        Employee
                      </Button>
                    </div>
                  </div>

                  <Card.Body>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        onChange={onInputChangelogin}
                        value={formInputs.email}
                        placeholder="Enter email"
                      />
                      {error && error.email ? (
                        <span className="text-danger">{error.email}</span>
                      ) : (
                        ""
                      )}
                      <Form.Text className="text-muted"></Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>Password</Form.Label>
                      <div className="passIcons">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={formInputs.password}
                          onChange={onInputChangelogin}
                          placeholder="Password"
                        />
                        {showPassword ? (
                          <VisibilityOffOutlinedIcon
                            onClick={() => onClickEye()}
                          />
                        ) : (
                          <VisibilityOutlinedIcon
                            onClick={() => onClickEye()}
                          />
                        )}
                      </div>
                      {error && error.password ? (
                        <span className="text-danger">{error.password}</span>
                      ) : (
                        ""
                      )}
                    </Form.Group>
                    {errorAPI && errorAPI !== "" && errorAPI.length > 0 ? (
                      <span className="text-danger">{errorAPI}</span>
                    ) : (
                      ""
                    )}
                    <Button
                      variant="primary"
                      type="button"
                      className="w-100 mb-3"
                      onClick={onSubmitLogin}
                    >
                      Submit
                    </Button>
                    {/* <Form.Text className="forgot-password d-flex justify-content-center mb-0">
                      <Link to="#">Forgot your password??</Link>
                    </Form.Text> */}
                  </Card.Body>
                </Card>
              </form>
            </div>
          </Col>
          <Col
            xxl={4}
            xl={6}
            lg={6}
            md={6}
            sm={12}
            className="px-0 d-sm-block d-none"
          >
            <div className="right-content centering-box">
              <div className="inner-box">
                <div className="login-content">
                  <h2>
                    Welcome!
                    <Image
                      src={victoryHand}
                      alt={"Victory hand Image"}
                      className="ms-2"
                      fluid
                    />
                  </h2>
                  <h3>
                    <span>at</span>&nbsp;IT Idol Technologies
                  </h3>
                </div>
                <Image
                  src={loginUser}
                  className="login-img"
                  alt={"login user"}
                  fluid
                />
                <div className="box thumb-box rounded-circle centering-box">
                  <div className="thumb-inner-box rounded-circle centering-box">
                    <Image src={thumb} alt={"Thumb Image"} fluid />
                  </div>
                </div>
                <div className="box heart-box rounded-circle centering-box">
                  <div className="heart-inner-box rounded-circle centering-box">
                    <Image src={redHeart} alt={"Red Heart Image"} fluid />
                  </div>
                </div>
                <div className="box hand-box rounded-circle centering-box">
                  <div className="hand-inner-box rounded-circle centering-box">
                    <Image src={handShake} alt={"Hand Shake Image"} fluid />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
